import $ from 'jquery';
import analytics from '../../services/analytics_service';
import config from '../../config';

export default () => {
    if (config.get('featureFlags.piwikEnabled') === true) {
        analytics.enableHeartBeatTimer();
        analytics.trackContentImpressions();

        const $document = $(document);
        const setUpClickEvents = (conf) => {
            const { selector, name, value } = conf;
            $document.on('click', selector, function () {
                // console.log(name);
                analytics.trackClick(name, value);
            });
        };
        [
            {
                selector: '.hamburger-click-area',
                name: 'hamburger',
                value: document.location.href
            }
        ].forEach(setUpClickEvents);
    }


    $(document).on("click", "a", function () {
        const GaAction = $(this).data('event-action');

        function getRootUrl() {
            return window.location.origin ? window.location.origin : window.location.protocol + '/' + window.location.host + '/';
        }

        const SiteUrl = getRootUrl();

        if (GaAction === 'Share:Facebook') {
            ga('send', 'social', 'Facebook', 'share', SiteUrl);
            ga('rollup.send', 'social', 'Facebook', 'share', SiteUrl);
        }

        if (GaAction === 'Share:Twitter') {
            ga('send', 'social', 'Twitter', 'tweet', SiteUrl);
            ga('rollup.send', 'social', 'Twitter', 'tweet', SiteUrl);
        }

        if (GaAction === 'Share:Linkedin') {
            ga('send', 'social', 'Linkedin', 'share', SiteUrl);
            ga('rollup.send', 'social', 'Linkedin', 'share', SiteUrl);
        }

        if (GaAction === 'Share:Email') {
            ga('send', 'social', 'Email', 'email', SiteUrl);
            ga('rollup.send', 'social', 'Email', 'email', SiteUrl);
        }

        if (GaAction === 'Clicked: Announcement') {
            ga('send', 'event', 'User', 'Clicked: Announcement', 'Google IO');
            ga('rollup.send', 'event', 'User', 'Clicked: Announcement', 'Google IO');
        }
    });
};
